var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSentiment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sentiment",
    transform: "translate(0.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    transform: "translate(-0.107)",
    fill: "none",
    stroke: "#256f92",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3031",
    "data-name": "Group 3031",
    transform: "translate(9.001 11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3030",
    "data-name": "Group 3030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    transform: "translate(-0.107)",
    fill: "none",
    stroke: "#256f92",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    transform: "translate(11.893)",
    fill: "none",
    stroke: "#256f92",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_519",
    "data-name": "Line 519",
    x2: 13,
    transform: "translate(1.264 10.5)",
    fill: "none",
    stroke: "#256f92",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentiment);
export default __webpack_public_path__ + "static/media/Sentiment.c8f42a9113c81d4e4f2b7fe2569145c0.svg";
export { ForwardRef as ReactComponent };